import { useFormContext, Controller } from 'react-hook-form';
import Input, { IPropsInput } from 'ui/components/Input/Input';

interface IProps {
  name: string;
}

export const RHFInput = ({ name, ...other }: IProps & IPropsInput) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Input {...field} error={!!error} helperText={error?.message} {...other} />
      )}
      rules={{ required: true }}
    />
  );
};

export default RHFInput;
